module.exports = __webpack_public_path__ + "static/floral 4 3000x3000-038419c547a14c5ae8041e6e44dcd210.jpg";